module.exports = __webpack_public_path__ + "static/media/php.0bc4619f.png";